module.exports = __webpack_public_path__ + "static/media/company.a18dd878.svg";